import { getInstitutionLevels } from 'modules/Core/Layout/App/Header/HeaderInstitutionIds/HeaderInstitutionIds.utils';

const LOCKED_LEVELS = [
  { name: 'group', filterName: 'group_id', camelCaseName: 'groupId' },
  { name: 'unit', filterName: 'unit_id', camelCaseName: 'unitId' },
  { name: 'school', filterName: 'school_id', camelCaseName: 'schoolId' },
];

const toId = (value) => {
  const id = Number(value);
  return Number.isFinite(id) && id > 0 ? id : null;
};

// A level is locked only where the API scopes the user to it as well: a teacher
// carries all three ids in the payload but `find_by_user` gives them nothing.
const lockedLevelsOf = (user) => {
  const scopedLevels = getInstitutionLevels(user?.user_type);

  return LOCKED_LEVELS.filter(
    ({ name }) => scopedLevels.includes(name) && toId(user?.[name]?.id)
  );
};

const collectLockedIds = (user, keyName) =>
  lockedLevelsOf(user).reduce(
    (locked, level) => ({
      ...locked,
      [level[keyName]]: toId(user[level.name].id),
    }),
    {}
  );

const getLockedInstitutionIds = (user) => collectLockedIds(user, 'filterName');

const getLockedInstitutionIdsCamelCase = (user) =>
  collectLockedIds(user, 'camelCaseName');

/**
 * Only the keys a given filter state declares: a screen that filters by group
 * alone must not start sending unit_id and school_id.
 */
const pickLockedIds = (lockedIds, filtersShape) =>
  Object.keys(lockedIds).reduce(
    (picked, key) =>
      key in filtersShape ? { ...picked, [key]: lockedIds[key] } : picked,
    {}
  );

// `locked` drives the menu, `required` drives the chip's remove button. They stay
// separate because Simulation Results already uses `required` on its own.
const narrowToLockedOption = (list = [], lockedId, fallbackEntity) => {
  if (!lockedId) return list;

  const selected =
    list?.find((item) => toId(item?.id) === lockedId) || fallbackEntity;

  return [{ ...selected, locked: true, required: true }];
};

const narrowLevelOptions = (user, levelName, list) => {
  const level = lockedLevelsOf(user).find(({ name }) => name === levelName);

  if (!level) return list;

  return narrowToLockedOption(list, toId(user[levelName].id), user[levelName]);
};

const omitLockedIds = (params, user) =>
  Object.keys(getLockedInstitutionIds(user)).reduce(
    (omitted, key) => ({ ...omitted, [key]: undefined }),
    params
  );

export {
  getLockedInstitutionIds,
  getLockedInstitutionIdsCamelCase,
  pickLockedIds,
  narrowLevelOptions,
  omitLockedIds,
};
